// removed by extract-text-webpack-plugin
module.exports = {"links":"Navigation__links___37IHV"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Main/Navigation/Navigation.scss
// module id = 925
// module chunks = 0